import { LayoutItem } from "grid-layout-plus/src/helpers/types";

export interface DashboardLayoutItem extends LayoutItem {
	storedDocumentId: string;
	displayAs: "graph" | "table" | "single-metric";
}

export type DashboardLayout = Array<DashboardLayoutItem>;

export const a4PageHeightInPx = 2088; // Constant don't ask why
export const a4PageHeaderInPx = 120; // This is the small bar with dashboard title and date we add at the top
